module.exports = __webpack_public_path__ + "img/erweima1.7733a9a6.png";